import { deepPurple } from "@mui/material/colors";

export const anomaliesHtmlStyle = {
  "& code": {
    backgroundColor: "#EDEFF6",
    padding: 0.25,
    borderRadius: 0.5,
    color: deepPurple["500"],
  },
};
